import { API } from 'aws-amplify';

const getSalesforceSsoUrl = async (): Promise<String> => {
    const response = await API.get('membership', '/salesforce-app-sso-url', {});
    return response.data;
};

export default getSalesforceSsoUrl;
